module.exports = __webpack_public_path__ + "img/map_Z4.3.C.03.0817d4ad.svg";